//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {ObserveVisibility} from 'vue-observe-visibility'
import CooperationModal from '../modals/CooperationModal.vue'
import FooterSocial from '~/components/common/footer/FooterSocial.vue' // @FIXME

export default {
  emits: ['isHeaderLogoVisible'],
  data() {
    return {
      isOpenModal: false
    }
  },
  directives: {
    ObserveVisibility
  },
  methods: {
    openModal() {
      this.isOpenModal = true
      this.$nextTick(() => {
        this.$modal.show('cooperation-modal')
      })
    },
    visibilityChangedLogo(isVisible, entry) {
      this.$emit('isHeaderLogoVisible', isVisible)
    }
  },

  components: {
    CooperationModal,
    FooterSocial
  },

  computed: {
    phoneCall() {
      return (this.appVars['Телефон'] || '').replace(/\D+/g, '')
    },

    currentYear: function () {
      return new Date().getFullYear()
    }
  },

  props: {
    appVars: {
      type: Object
    },
    menu: {
      type: Array
    },
    secondMenu: {
      type: Array
    }
  }
}
